import { getContractBasedDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from '../../store/rootReducer';

export const rateChargePFPDataSelector = getContractBasedDataSelector((state: RootState) => state.rateChargePFP);
export const rateChargePFADataSelector = getContractBasedDataSelector((state: RootState) => state.rateChargePFA);
export const rateChargePMDataSelector = getContractBasedDataSelector((state: RootState) => state.rateChargePM);
export const riskRateSelector = getContractBasedDataSelector((state: RootState) => state.riskRate);
export const FinanceSimulationModelCatalogContentSelector = (state: RootState) => state.content.financeSimulationModels;
